import { EFilterNames, TyreFilter } from "@tm/models"
import { ListState } from "../model"
import { SummaryState } from "../../../summary/business"

export function getSelectedCriteria(state: ListState, byMatchCode?: boolean, excludeSeason?: boolean): TyreFilter[] {
    const {
        filters,
        selectedFilters,
        lastSearch: { season },
    } = state
    const fuelEfficiency = getAllFiltersBefore(filters.fuelEfficiency, selectedFilters.fuelEfficiency)
    const wetGripClass = getAllFiltersBefore(filters.wetGripClass, selectedFilters.wetGripClass)
    const externalRolling = getAllFiltersBefore(filters.externalRolling, selectedFilters.externalRolling)

    let selectedSeason: TyreFilter | undefined

    if (!byMatchCode && !excludeSeason) {
        if (selectedFilters.season) {
            selectedSeason = selectedFilters.season
        } else if (season?.length) {
            selectedSeason = { value: season, query: season, group: EFilterNames.season }
        }
    }

    const result: TyreFilter[] = [
        ...fuelEfficiency,
        ...wetGripClass,
        ...externalRolling,
        ...(selectedFilters.speedIndex ?? []),
        ...(selectedFilters.loadIndex ?? []),
        ...(selectedFilters.manufacturer ?? []),
        ...(selectedFilters.weight ?? []),
        ...(selectedFilters.oeIdentifier ?? []),
        ...(selectedFilters.extras ?? []),
        ...(selectedFilters.application ?? []),
        ...(selectedFilters.axlePosition ?? []),
        ...(selectedFilters.construction ?? []),
        ...(selectedFilters.ev ?? []),
        ...(selectedFilters.plyRating ?? []),
        ...(selectedFilters.seal ?? []),
        ...(selectedFilters.sidewall ?? []),
        ...(selectedFilters.threePMSF ?? []),
        ...(selectedFilters.hardness ?? []),
        ...(selectedFilters.tubeType ?? []),
        ...(selectedFilters.tyreTread ?? []),
    ]
    if (selectedSeason) {
        result.push(selectedSeason as TyreFilter)
    }

    return result
}

function getAllFiltersBefore(items: TyreFilter[], selected?: TyreFilter) {
    return !selected ? [] : items.filter((item) => item.query <= selected.query)
}

export function getSelectedCriteriaForSummary(state: SummaryState, excludeSeason?: boolean): TyreFilter[] {
    const { selectedFilters } = state

    const filters: TyreFilter[] = [
        ...(selectedFilters.speedIndex ? [selectedFilters.speedIndex] : []),
        ...(selectedFilters.loadIndex ? [selectedFilters.loadIndex] : []),
        ...(selectedFilters.oeIdentifier ? [selectedFilters.oeIdentifier] : []),
    ]

    if (!excludeSeason && selectedFilters.season) {
        filters.push(selectedFilters.season)
    }

    return filters
}
